import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { Tooltip } from '@doxyme/ui';
import './reset-button.scss';
export const ResetButton = ({ onClick, disabled = false, accentColor, resetButtonId, }) => {
    const intl = useIntl();
    const formatMessage = intl.formatMessage.bind(intl);
    // Set CSS variable on document root so tooltip (rendered in portal) can access it
    useEffect(() => {
        if (accentColor) {
            document.documentElement.style.setProperty('--reset-tooltip-accent-color', accentColor);
        }
        return () => {
            // Cleanup: remove the CSS variable when component unmounts
            document.documentElement.style.removeProperty('--reset-tooltip-accent-color');
        };
    }, [accentColor]);
    return (<div className="reset-button-wrapper">
      <Tooltip className="reset-button-tooltip" tabIndex={-1} content={formatMessage({
            id: 'account.settings.clinic.branding.reset-to-default',
        })} size="small" theme="dark" pointerPosition="top-center" hideTimeout={0} debounceMs={0}>
        <button id={resetButtonId} type="button" className="reset-button" onClick={onClick} disabled={disabled} aria-label={formatMessage({
            id: 'account.settings.clinic.branding.reset-to-default',
        })}>
          <i className="icon icon-close"></i>
        </button>
      </Tooltip>
    </div>);
};
